import { SVGProps } from "react";

const ChevronUpV3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.828}
    height={8.414}
    viewBox="0 0 14.828 8.414"
    {...props}
  >
    <path
      fill="none"
      stroke="#404040"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.414 7-6-6-6 6"
      data-name="05d672bf2ec15f434a544f7a2214100f"
    />
  </svg>
);
export default ChevronUpV3;
